// Services and drugs that apply to an enrollee's programme (users.sector; a dependant's is its principal's).
//
// Catalog items carry the programmes they are tagged for in `sectors` (service_drug_sectors rows, `name` =
// programme name), returned by service-agency/{id} and drug-agency/{id}. An item tagged for no programme
// applies to everyone; a tagged item only to enrollees of those programmes. With no programme known, the
// whole catalog is returned.

function norm(value) {
  return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
}

export function enrolleeProgramme(enrollee) {
  if (!enrollee) return "";
  return enrollee.sector || (enrollee.user && enrollee.user.sector) || "";
}

export function catalogList(payload) {
  if (Array.isArray(payload)) return payload;
  return payload && Array.isArray(payload.data) ? payload.data : [];
}

export function forProgramme(items, programme) {
  const list = catalogList(items);
  const wanted = norm(programme);
  if (!wanted) return list;
  return list.filter((item) => {
    const tags = (item.sectors || []).map((s) => norm(s && (s.name || s))).filter(Boolean);
    return !tags.length || tags.includes(wanted);
  });
}
